import { useState } from 'react'

interface TagPreviewData {
  tag1: string
  tag2: string
  count1: number
  count2: number
}

export function useTagPreview() {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false)
  const [previewData, setPreviewData] = useState<TagPreviewData | null>(null)

  const openPreview = (
    tag1: string,
    tag2: string,
    count1: number,
    count2: number
  ) => {
    setPreviewData({ tag1, tag2, count1, count2 })
    setIsPreviewOpen(true)
  }

  const closePreview = () => {
    setIsPreviewOpen(false)
    setPreviewData(null)
  }

  return {
    isPreviewOpen,
    previewData,
    openPreview,
    closePreview,
  }
}
